import type { GuaranteeItem, ValidationItem, ReceivableItem, GuaranteeTitleItem } from './collateralUtils';

let guarantees: GuaranteeItem[] = [];
let validations: ValidationItem[] = [];
let receivables: ReceivableItem[] = [];
let guaranteeTitles: GuaranteeTitleItem[] = [];

// Tag colors
let tagColors: Record<string, string> = {};

// --- Guarantees ---
export const getGuarantees = (): GuaranteeItem[] => guarantees;

export const updateGuarantee = (id: number, updates: Partial<GuaranteeItem>): void => {
    const idx = guarantees.findIndex(g => g.id === id);
    if (idx !== -1) guarantees[idx] = { ...guarantees[idx], ...updates };
};

export const addGuarantee = (item: GuaranteeItem): void => {
    guarantees = [item, ...guarantees];
};

// --- Validations ---
export const getValidations = (): ValidationItem[] => validations;

export const updateValidation = (id: number, updates: Partial<ValidationItem>): void => {
    const idx = validations.findIndex(v => v.id === id);
    if (idx !== -1) validations[idx] = { ...validations[idx], ...updates };
};

export const addValidation = (item: ValidationItem): void => {
    validations = [item, ...validations];
};

// --- Receivables ---
export const getReceivables = (validationId?: number): ReceivableItem[] =>
    validationId != null ? receivables.filter(r => r.validationId === validationId) : receivables;

export const updateReceivable = (id: number, updates: Partial<ReceivableItem>): void => {
    const idx = receivables.findIndex(r => r.id === id);
    if (idx !== -1) receivables[idx] = { ...receivables[idx], ...updates };
};

// --- Tag colors (shared) ---
export const getTagColor = (tag: string): string => tagColors[tag] || 'blue';
export const setTagColor = (tag: string, color: string): void => { tagColors[tag] = color; };

// --- Guarantee Titles ---
export const getGuaranteeTitles = (guaranteeId?: number): GuaranteeTitleItem[] =>
    guaranteeId != null ? guaranteeTitles.filter(t => t.guaranteeId === guaranteeId) : guaranteeTitles;

export const updateGuaranteeTitle = (id: number, updates: Partial<GuaranteeTitleItem>): void => {
    const idx = guaranteeTitles.findIndex(t => t.id === id);
    if (idx !== -1) guaranteeTitles[idx] = { ...guaranteeTitles[idx], ...updates };
};

// Backward compatibility
export const getValidationData = (): any[] => validations;
